import React, { useEffect, useState } from 'react'
import { TreeSelect, Form, Select } from 'antd';
import { Box, Button, Heading, Spinner, Text, VStack, useToast } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { TARM_AWS_URL } from '../../api/api';
const { SHOW_CHILD } = TreeSelect;
const SkillsSelector = () => {
    const { state } = useLocation();
    const { run_id, filename, jobProfileName, requiredJobTitles, optionalSkillsTreeData, mandatorySkillsTreeData } = state;
    const mandatorySkillsOptions = state.mandatorySkills.map(item => ({ "label": item, "value": item }))
    const optionalSkillsOptions = state.optionalSkills.map(item => ({ "label": item, "value": item }))
    const [mandatorySkillsTreeValues, setMandatorySkillsTreeValues] = useState([]);
    const [optionalSkillsTreeValues, setOptionalSkillsTreeValues] = useState([]);
    const [mandatorySkills, setMandatorySkills] = useState(state.mandatorySkills);
    const [optionalSkills, setOptionalSkills] = useState(state.optionalSkills);
    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const [source] = useState(axios.CancelToken.source());
    const navigate = useNavigate();
    const toast = useToast();

    useEffect(() => {
        return () => {
            if (source) {
                source.cancel();
            }
        };
    }, []);

    const onChangeMandatorySkills = (value) => {
        console.log(`Selected: ${value}`);
        setMandatorySkills(value)
    };

    const onChangeOptionalSkills = (value) => {
        console.log(`Selected: ${value}`);
        setOptionalSkills(value)
    };

    const onChangeMandatorySkillsTreeSelect = (value, label, extra) => {
        console.log(value)
        console.log(label)
        console.log(extra)
        setMandatorySkillsTreeValues(value);
    };
    const onChangeOptionalSkillsTreeSelect = (value, label, extra) => {
        console.log(value)
        console.log(label)
        console.log(extra)
        setOptionalSkillsTreeValues(value);
    };

    const handleNextBtn = async () => {
        setIsBtnLoading(true)
        const mSkillsTreeValues = mandatorySkillsTreeValues.map(str => str.split('__')[0])
        const oSkillsTreeValues = optionalSkillsTreeValues.map(str => str.split('__')[0])
        const mergedMandatorySkills = [...new Set([...mandatorySkills, ...mSkillsTreeValues])];
        const mergedOptionalSkills = [...new Set([...optionalSkills, ...oSkillsTreeValues])];
        const sMandatorySkills = mergedMandatorySkills.map(skill => ({ "Skill_Type": "MandatorySkills", "Keyword": skill, "Weightage": 1, "file": filename }))
        const sOptionalSkills = mergedOptionalSkills.map(skill => ({ "Skill_Type": "OptionalSkills", "Keyword": skill, "Weightage": 0.5, "file": filename }))
        const serializedRowData = [...new Set([...sMandatorySkills, ...sOptionalSkills])];
        const allSkillsArr = [...mSkillsTreeValues, ...oSkillsTreeValues, ...mergedMandatorySkills, ...mergedOptionalSkills]
        console.log("serializedRowData", serializedRowData)
        const jdstring = allSkillsArr.sort().join(",");
        try {
            const res = await TARM_AWS_URL.post(
                "jd-parser/get-matching-jds",
                {
                    jdstring: jdstring,
                },
                {
                    cancelToken: source.token,
                }
            );
            console.log(res.data);
            const matchingJds = res.data;
            navigate("configure-jd", {
                state: {
                    serializedRowData: serializedRowData,
                    run_id: run_id,
                    jobProfileName: jobProfileName,
                    requiredJobTitle: requiredJobTitles.map(rjt => ({ 'id': rjt, 'text': rjt })),
                    matchingJds: matchingJds
                },
            });
        } catch (error) {
            console.log(error);
            toast({
                title: error.message,
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        } finally {
            setIsBtnLoading(false)
        }
    }

    const mandatorySkillsProps = {
        treeData: mandatorySkillsTreeData,
        size: "large",
        value: mandatorySkillsTreeValues,
        onChange: onChangeMandatorySkillsTreeSelect,
        treeCheckable: true,
        showCheckedStrategy: SHOW_CHILD,
        placeholder: 'Please select',
        style: {
            width: '100%',
        },
    };
    const optionalSkillsProps = {
        treeData: optionalSkillsTreeData,
        size: "large",
        value: optionalSkillsTreeValues,
        onChange: onChangeOptionalSkillsTreeSelect,
        treeCheckable: true,
        showCheckedStrategy: SHOW_CHILD,
        placeholder: 'Please select',
        style: {
            width: '100%',
        },
    };
    return (
        <VStack>
            <Heading>Skills Selector</Heading>
            <br />
            <Box borderWidth="3px" borderRadius="lg" p="10" width="750px" height="80vh" overflowY="auto">
                <Box display='flex' alignItems="baseline">
                    <Text mr="2">Job Profile:</Text>
                    <Heading size="md">{jobProfileName}</Heading>
                </Box>
                <br />
                <Form.Item>
                    Extracted Mandatory Skills:
                    <Select
                        mode="multiple"
                        size="large"
                        style={{ width: '100%' }}
                        placeholder="Please select"
                        defaultValue={mandatorySkills}
                        onChange={onChangeMandatorySkills}
                        options={mandatorySkillsOptions}
                    />
                </Form.Item>

                <Form.Item>
                    Extracted Optional Skills:
                    <Select
                        mode="multiple"
                        size="large"
                        style={{ width: '100%' }}
                        placeholder="Please select"
                        defaultValue={optionalSkills}
                        onChange={onChangeOptionalSkills}
                        options={optionalSkillsOptions}
                    />
                </Form.Item>

                <Text noOfLines={[1, 2, 3]} mb="2">
                    We have extracted all the skills, with their corresponding  <i>Complimentary, Supplementary, Competing, Acronyms and Parent Tech Skills</i>
                </Text>

                <Form.Item>
                    Mandatory Skills:
                    <TreeSelect {...mandatorySkillsProps} />
                </Form.Item>

                <Form.Item>
                    Optional Skills:
                    <TreeSelect {...optionalSkillsProps} />
                </Form.Item>
                <Box textAlign="end" mt="4">
                    <Button
                        type="submit"
                        colorScheme="blue"
                        mr={2}
                        onClick={handleNextBtn}
                        disabled={
                            !(jobProfileName && mandatorySkills.length > 0) || isBtnLoading
                        }
                    >
                        {isBtnLoading && <Spinner size="sm" mr={2} />}
                        Next
                    </Button>
                </Box>
            </Box>
        </VStack>
    )
}
export default SkillsSelector